/**
 * Required global object
 * - closing_window
 */
var ClosingWindow = {
    init: function() {
        $('a').click(ClosingWindow.removeBeforeUnloadEvent);
        ClosingWindow.initUnloadEvent();
    },

    initUnloadEvent: function() {
        $(window).off("beforeunload");
        $(window).on('beforeunload', ClosingWindow.events.onBeforeUnload);
        console.log("unload event is ready");
    },

    saveCart: function() {
        $.ajax({
            url: closing_window.save_cart_queue_url,
            type: "POST",
            dataType: "JSON",

            headers: {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr('content')
            }
        });
    },

    removeBeforeUnloadEvent: function() {
        $(window).off("beforeunload");
    }
};

ClosingWindow.events = {
    onBeforeUnload: function(e) {
        ClosingWindow.initUnloadEvent();
        ClosingWindow.saveCart();

        function sleep(delay) {
          var start = new Date().getTime();
          while (new Date().getTime() < start + delay);
        }

        console.log("Blocking for 1 second...");
        sleep(1000);
        console.log("Done!!");

        return "";
    }
};
